module.exports = __webpack_public_path__ + "static/media/bg.a1249422.png";